import { Link } from 'react-router-dom'
import { t } from '@/lib/ui'
import { KELA_FI_URL, MODEL_SNAPSHOT } from '@/lib/site'

// Footer on every page (DESIGN-BRIEF §3): repeats the disclaimer, points to
// kela.fi for real services, names the author, and carries the model's snapshot
// date (objection #6 — the research artifact states its as_of on every page).
// Copy is N0's front-page footer, assembled from ui.fi.json.
export function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-hairline bg-paper">
      <div className="mx-auto max-w-shell space-y-3 px-4 py-8 text-sm text-muted">
        <p className="max-w-prose">{t('footer.disclaimer')}</p>

        <p>
          <span className="font-medium text-ink">{t('footer.realKelaLead')}</span>{' '}
          <a
            href={KELA_FI_URL}
            className="text-accent underline decoration-hairline underline-offset-2 hover:decoration-accent"
            rel="noreferrer"
          >
            {t('footer.realKelaLinkLabel')}
          </a>
        </p>

        <div className="flex flex-col gap-1 border-t border-hairline pt-3 sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-2">
          <span>{t('footer.author')}</span>
          <span aria-hidden="true" className="hidden sm:inline">
            ·
          </span>
          <span>
            {t('footer.methodLead')}{' '}
            <Link
              to="/tarkoitus"
              className="text-accent underline decoration-hairline underline-offset-2 hover:decoration-accent"
            >
              {t('footer.methodLinkLabel')}
            </Link>
          </span>
          <span aria-hidden="true" className="hidden sm:inline">
            ·
          </span>
          <span>
            {t('footer.snapshotLead')} <time dateTime={MODEL_SNAPSHOT}>{MODEL_SNAPSHOT}</time>
          </span>
        </div>
      </div>
    </footer>
  )
}
